/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { StartValidationCommand } from '../models/start-validation-command';
import { SubmitApplyCommand } from '../models/submit-apply-command';
import { SubmitValidationCommand } from '../models/submit-validation-command';

@Injectable({
  providedIn: 'root',
})
export class RegistrationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation advertisementIdValid
   */
  static readonly AdvertisementIdValidPath = '/api/Registration/AdvertisementIdValid/{code}';

  /**
   * Hirdetésazonosító ellenőrzése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `advertisementIdValid$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  advertisementIdValid$Plain$Response(params: {
    code: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.AdvertisementIdValidPath, 'get');
    if (params) {
      rb.path('code', params.code, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Hirdetésazonosító ellenőrzése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `advertisementIdValid$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  advertisementIdValid$Plain(params: {
    code: string;
  },
  context?: HttpContext

): Observable<boolean> {

    return this.advertisementIdValid$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Hirdetésazonosító ellenőrzése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `advertisementIdValid()` instead.
   *
   * This method doesn't expect any request body.
   */
  advertisementIdValid$Response(params: {
    code: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.AdvertisementIdValidPath, 'get');
    if (params) {
      rb.path('code', params.code, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Hirdetésazonosító ellenőrzése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `advertisementIdValid$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  advertisementIdValid(params: {
    code: string;
  },
  context?: HttpContext

): Observable<boolean> {

    return this.advertisementIdValid$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation submitApply
   */
  static readonly SubmitApplyPath = '/api/Registration/SubmitApply';

  /**
   * Előregisztráció befejezése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `submitApply()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  submitApply$Response(params?: {
    body?: SubmitApplyCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.SubmitApplyPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Előregisztráció befejezése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `submitApply$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  submitApply(params?: {
    body?: SubmitApplyCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.submitApply$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation startValidation
   */
  static readonly StartValidationPath = '/api/Registration/StartValidation';

  /**
   * Email cím vagy telefonszám hitelesítőkód küldése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startValidation()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startValidation$Response(params?: {
    body?: StartValidationCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.StartValidationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Email cím vagy telefonszám hitelesítőkód küldése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startValidation$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  startValidation(params?: {
    body?: StartValidationCommand
  },
  context?: HttpContext

): Observable<void> {

    return this.startValidation$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation checkValidationCode
   */
  static readonly CheckValidationCodePath = '/api/Registration/CheckValidationCode';

  /**
   * Hitelesítőkód ellenőrzése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkValidationCode$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkValidationCode$Plain$Response(params?: {
    body?: SubmitValidationCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.CheckValidationCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Hitelesítőkód ellenőrzése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkValidationCode$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkValidationCode$Plain(params?: {
    body?: SubmitValidationCommand
  },
  context?: HttpContext

): Observable<boolean> {

    return this.checkValidationCode$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

  /**
   * Hitelesítőkód ellenőrzése.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkValidationCode()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkValidationCode$Response(params?: {
    body?: SubmitValidationCommand
  },
  context?: HttpContext

): Observable<StrictHttpResponse<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, RegistrationService.CheckValidationCodePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Hitelesítőkód ellenőrzése.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `checkValidationCode$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  checkValidationCode(params?: {
    body?: SubmitValidationCommand
  },
  context?: HttpContext

): Observable<boolean> {

    return this.checkValidationCode$Response(params,context).pipe(
      map((r: StrictHttpResponse<boolean>) => r.body as boolean)
    );
  }

}
